/* 换主题颜色 */

export const classnames = function classnames(...args) {
    return args.join(' ');
};
export const classNames = classnames;
